export const defaultAccountTab = "active";

export const accountTabs: {
  value: string;
  label: string;
}[] = [
  {
    value: "active",
    label: "active accounts",
  },
  {
    value: "inactive",
    label: "inactive accounts",
  },
];
